import { emitEvent } from "./emit-event";
import { EVENT_TYPE } from "./events";

// Code imported and tweaked, originally from Jentis.
// Tracks all general link clicks on the site.
// Note that events with track type 'event' are sent using the Beacon Web API to Jentis, and are guaranteed
// to be sent even if the current page closes/navigates away (which typically happens when clicking a link).
document.addEventListener("click", function (event) {
  const eventTarget = event.target as HTMLElement | null | undefined;

  const target = eventTarget?.closest<HTMLAnchorElement>("a[href]"); // Get the closest ancestor <a> element with an href attribute

  if (target) {
    const href = target.href; // The URL to navigate to

    // Prepare the base structure of the event object with a default name
    const eventObject = {
      "group": "click_event",
      "name": "other_clicks", // Default event name
      "target": "(removed)", // Default to anonymized target
      "text": "(removed)", // Default to anonymized text
      "conversion_event": 0 // Default to 0 for non-conversion clicks
    };

    // Determine the event name and conversion status
    if (
      href.includes("//anicura.provetcloud.com") ||
      href.includes("petleo.app") ||
      href.includes("abupet.com") ||
      href.includes("app.petsxl") ||
      href.includes("appointment-registration") ||
      href.includes("booking.vetstoria.com")
    ) {
      eventObject.name = "click_to_booking_service";

      eventObject.conversion_event = 1; // Mark as conversion event
    } else if (href.startsWith("tel:")) {
      eventObject.name = "click_to_clinic_phone_number";

      eventObject.target = href;
      eventObject.text = target.textContent?.trim() ?? "";
      eventObject.conversion_event = 1; // Mark as conversion event
    } else if (href.startsWith("mailto:")) {
      eventObject.name = "click_to_clinic_email";

      eventObject.conversion_event = 1; // Mark as conversion event
    } else if (href.includes("www.google.com/maps") || href.includes("maps.google.com")) {
      eventObject.name = "click_to_google_maps";

      eventObject.target = "https://www.google.com/maps/dir/(removed)"; // Include actual URL for navigable links
      eventObject.text = target.textContent?.trim() ?? ""; // Include actual text for navigable links
    } else if (href.includes("https://www.anicura.")) {
      eventObject.name = "click_to_other_anicura_sites";

      const domain = new URL(href).hostname; // Extract domain from href
      eventObject.target = domain; // Include actual domain for other AniCura sites
      eventObject.text = target.textContent?.trim() ?? ""; // Include actual text for navigable links
    } else {
      const socialPlatforms = [
        "facebook.com",
        "twitter.com",
        "instagram.com",
        "linkedin.com"
      ];

      const matchedPlatform = socialPlatforms.find(platform => href.includes(platform));

      if (matchedPlatform) {
        const platformName = matchedPlatform.split(".")[0]; // Extract platform name, e.g., "facebook"

        eventObject.name = `social_media_click_${platformName}`; // Adjusted to the requested format
        eventObject.target = href; // Include actual URL for navigable links
        eventObject.text = target.textContent?.trim() ?? ""; // Include actual text for navigable links
      } else {
        // For other clicks, include actual URL and text
        eventObject.name = "other_clicks";
        eventObject.target = href;
        eventObject.text = target.textContent?.trim() ?? "";
      }
    }

    emitEvent(EVENT_TYPE.event, eventObject, false);
  }
});
